// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hmi-home {
    --hmi-bg: #F5F7FB;
    --hmi-card: #FFFFFF;
    --hmi-accent: #2563EB;
    --hmi-accent-ink: #FFFFFF;
    --hmi-text: #0F172A;
    --hmi-muted: #475569;
    --hmi-hover: #EEF4FF;
    --hmi-border: #E2E8F0;
    --hmi-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 10px 28px rgba(15, 23, 42, 0.05);
    --hmi-row: #F8FAFC;
    --hmi-good: #047857;
    --hmi-good-bg: #ECFDF5;
    --hmi-warn: #B45309;
    --hmi-warn-bg: #FFFBEB;
    --hmi-danger: #B91C1C;
    --hmi-danger-bg: #FEF2F2;
    --hmi-input: #FFFFFF;
    color-scheme: light;
    box-sizing: border-box;
    min-height: calc(100vh - 64px);
    padding: 28px 32px 40px;
    background: var(--hmi-bg);
    color: var(--hmi-text);
    font-family: "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

.hmi-home[data-theme="dark"] {
    --hmi-bg: #0B1220;
    --hmi-card: #172033;
    --hmi-accent: #38BDF8;
    --hmi-accent-ink: #082033;
    --hmi-text: #F1F5F9;
    --hmi-muted: #CBD5E1;
    --hmi-hover: #1E293B;
    --hmi-border: #334155;
    --hmi-shadow: 0 1px 2px rgba(0, 0, 0, 0.28), 0 12px 32px rgba(0, 0, 0, 0.22);
    --hmi-row: #121A2B;
    --hmi-good: #34D399;
    --hmi-good-bg: rgba(52, 211, 153, 0.12);
    --hmi-warn: #FBBF24;
    --hmi-warn-bg: rgba(251, 191, 36, 0.12);
    --hmi-danger: #FCA5A5;
    --hmi-danger-bg: rgba(248, 113, 113, 0.12);
    --hmi-input: #0F172A;
    color-scheme: dark;
}

.hmi-home *,
.hmi-home *::before,
.hmi-home *::after {
    box-sizing: border-box;
}

.hmi-home h1,
.hmi-home h2,
.hmi-home p {
    margin: 0;
    color: var(--hmi-text);
}

.hmi-home__top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 24px;
    margin-bottom: 22px;
}

.hmi-home__eyebrow {
    margin-bottom: 6px;
    color: var(--hmi-accent);
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.hmi-home__intro h1 {
    color: var(--hmi-text);
    font-size: 32px;
    line-height: 1.15;
    font-weight: 700;
    letter-spacing: -0.03em;
}

.hmi-home p.hmi-home__subtitle {
    margin-top: 6px;
    color: var(--hmi-muted);
    font-size: 15px;
}

.hmi-home__meta {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 12px;
    min-width: min(100%, 520px);
}

.hmi-home__clock,
.hmi-home__refresh,
.hmi-home__theme {
    border: 1px solid var(--hmi-border);
    background: var(--hmi-card);
    box-shadow: var(--hmi-shadow);
}

.hmi-home__clock,
.hmi-home__refresh {
    border-radius: 14px;
    padding: 12px 14px;
    min-width: 220px;
}

.hmi-home__meta-label {
    display: block;
    margin-bottom: 4px;
    color: var(--hmi-muted);
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
}

.hmi-home__clock strong,
.hmi-home__refresh strong {
    display: block;
    font-size: 14px;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
}

.hmi-home__theme {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    height: 64px;
    padding: 0 16px;
    border-radius: 14px;
    color: var(--hmi-text);
    font: inherit;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    transition: border-color 0.15s ease, background-color 0.15s ease, color 0.15s ease;
}

.hmi-home__theme svg,
.hmi-home__shortcut svg,
.hmi-kpi__icon svg {
    width: 18px;
    height: 18px;
    display: block;
}

.hmi-home__theme:hover,
.hmi-home__theme:focus-visible,
.hmi-home__shortcut:hover,
.hmi-home__shortcut:focus-visible {
    border-color: var(--hmi-accent);
    outline: none;
}

.hmi-home__theme:focus-visible,
.hmi-home__shortcut:focus-visible,
.hmi-home__field input:focus-visible,
.hmi-home__field select:focus-visible,
.hmi-home__table button:focus-visible {
    outline: 2px solid var(--hmi-accent);
    outline-offset: 2px;
}

.hmi-home__refresh.is-refreshing strong {
    color: var(--hmi-accent);
}

.hmi-home__refresh.is-error {
    border-color: var(--hmi-danger);
}

.hmi-home__refresh-error {
    display: block;
    margin-top: 4px;
    color: var(--hmi-danger);
    font-size: 12px;
    font-weight: 600;
}

.hmi-home__shortcuts {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 22px;
}

.hmi-home__shortcuts a {
    text-decoration: none;
}

.hmi-home__shortcut {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    border: 1px solid var(--hmi-accent);
    border-radius: 12px;
    background: var(--hmi-card);
    color: var(--hmi-accent);
    font: inherit;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    box-shadow: var(--hmi-shadow);
    transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.hmi-home__shortcut:hover,
.hmi-home__shortcut:focus-visible {
    background: var(--hmi-accent);
    color: var(--hmi-accent-ink);
}

.hmi-home__kpis {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 14px;
    margin-bottom: 18px;
}

.hmi-kpi {
    display: flex;
    gap: 14px;
    align-items: center;
    min-height: 124px;
    padding: 18px 18px 16px;
    border: 1px solid var(--hmi-border);
    border-radius: 16px;
    background: var(--hmi-card);
    box-shadow: var(--hmi-shadow);
}

.hmi-kpi__icon {
    display: grid;
    place-items: center;
    width: 40px;
    height: 40px;
    flex: 0 0 40px;
    border-radius: 12px;
    background: rgba(37, 99, 235, 0.1);
    color: var(--hmi-accent);
}

.hmi-home[data-theme="dark"] .hmi-kpi__icon {
    background: rgba(56, 189, 248, 0.12);
}

.hmi-kpi--good .hmi-kpi__icon {
    background: var(--hmi-good-bg);
    color: var(--hmi-good);
}

.hmi-kpi--warn .hmi-kpi__icon {
    background: var(--hmi-warn-bg);
    color: var(--hmi-warn);
}

.hmi-home p.hmi-kpi__label {
    color: var(--hmi-muted);
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}

.hmi-kpi__value {
    margin: 6px 0 4px;
    color: var(--hmi-text);
    font-size: 30px;
    line-height: 1;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.03em;
}

.hmi-home p.hmi-kpi__hint {
    color: var(--hmi-muted);
    font-size: 12px;
    line-height: 1.4;
}

.hmi-home__panel {
    border: 1px solid var(--hmi-border);
    border-radius: 18px;
    background: var(--hmi-card);
    box-shadow: var(--hmi-shadow);
    overflow: hidden;
}

.hmi-home__panel-head {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 18px;
    padding: 18px 18px 14px;
    border-bottom: 1px solid var(--hmi-border);
}

.hmi-home__panel-head h2 {
    color: var(--hmi-text);
    font-size: 18px;
    letter-spacing: -0.02em;
}

.hmi-home .hmi-home__panel-head p {
    margin-top: 4px;
    color: var(--hmi-muted);
    font-size: 13px;
}

.hmi-home__tools {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 10px;
}

.hmi-home__field {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 200px;
}

.hmi-home__field span {
    color: var(--hmi-muted);
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
}

.hmi-home__field input,
.hmi-home__field select {
    height: 40px;
    width: 100%;
    max-width: none;
    padding: 0 12px;
    border: 1px solid var(--hmi-border);
    border-radius: 10px;
    background: var(--hmi-input);
    color: var(--hmi-text);
    font: inherit;
    font-size: 14px;
}

.hmi-home__state {
    padding: 36px 18px;
    color: var(--hmi-muted);
    text-align: center;
    font-size: 14px;
}

.hmi-home__state--error {
    color: var(--hmi-danger);
}

.hmi-home__table-wrap {
    width: 100%;
    overflow-x: auto;
}

.hmi-home__table {
    width: 100%;
    min-width: 760px;
    border-collapse: collapse;
}

.hmi-home__table th,
.hmi-home__table td {
    padding: 13px 16px;
    border-bottom: 1px solid var(--hmi-border);
    color: var(--hmi-text);
    text-align: left;
    vertical-align: middle;
    font-size: 14px;
    transition: background-color 0.15s ease;
}

.hmi-home__table th {
    background: var(--hmi-row);
    color: var(--hmi-muted);
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    white-space: nowrap;
}

.hmi-home__table button {
    padding: 0;
    border: 0;
    background: transparent;
    color: inherit;
    font: inherit;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    cursor: pointer;
}

.hmi-home__table button:hover {
    color: var(--hmi-accent);
}

.hmi-home__table tbody tr:last-child td {
    border-bottom: 0;
}

.hmi-home__table tbody tr:hover td {
    background: var(--hmi-hover);
}

.hmi-home__tag-name {
    font-weight: 600;
}

.hmi-home__value {
    color: var(--hmi-text);
    font-weight: 700;
    font-variant-numeric: tabular-nums;
}

.hmi-home__table td.hmi-home__time {
    color: var(--hmi-muted);
    font-variant-numeric: tabular-nums;
    letter-spacing: 0.01em;
    white-space: nowrap;
}

.hmi-home__status {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 9px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
}

.hmi-home__status::before {
    content: "";
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: currentColor;
}

.hmi-home__status.is-available {
    color: var(--hmi-good);
    background: var(--hmi-good-bg);
}

.hmi-home__status.is-missing {
    color: var(--hmi-warn);
    background: var(--hmi-warn-bg);
}

@media (max-width: 1100px) {
    .hmi-home__kpis {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 800px) {
    .hmi-home {
        padding: 18px 14px 28px;
    }

    .hmi-home__top,
    .hmi-home__panel-head {
        flex-direction: column;
        align-items: stretch;
    }

    .hmi-home__meta,
    .hmi-home__tools {
        justify-content: flex-start;
    }

    .hmi-home__intro h1 {
        font-size: 26px;
    }

    .hmi-home__clock,
    .hmi-home__refresh,
    .hmi-home__field {
        min-width: 0;
        width: 100%;
    }

    .hmi-home__theme {
        width: 100%;
        justify-content: center;
    }
}

@media (max-width: 560px) {
    .hmi-home__kpis {
        grid-template-columns: 1fr;
    }

    .hmi-home__shortcut {
        width: 100%;
        justify-content: center;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/HomePage.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,qBAAqB;IACrB,kFAAkF;IAClF,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,wBAAwB;IACxB,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,8BAA8B;IAC9B,uBAAuB;IACvB,yBAAyB;IACzB,sBAAsB;IACtB,oEAAoE;AACxE;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,qBAAqB;IACrB,4EAA4E;IAC5E,kBAAkB;IAClB,mBAAmB;IACnB,uCAAuC;IACvC,mBAAmB;IACnB,uCAAuC;IACvC,qBAAqB;IACrB,0CAA0C;IAC1C,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;;;IAGI,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,SAAS;IACT,2BAA2B;AAC/B;;AAEA;;;IAGI,mCAAmC;IACnC,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;;IAEI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;;IAEI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,kFAAkF;AACtF;;AAEA;;;IAGI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;;;;IAII,+BAA+B;IAC/B,aAAa;AACjB;;AAEA;;;;;IAKI,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,wBAAwB;IACxB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,mCAAmC;IACnC,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,kFAAkF;AACtF;;AAEA;;IAEI,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,iBAAiB;IACjB,uBAAuB;IACvB,mCAAmC;IACnC,mBAAmB;IACnB,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,kCAAkC;IAClC,wBAAwB;AAC5B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kCAAkC;IAClC,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;IACnB,2BAA2B;IAC3B,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,SAAS;IACT,uBAAuB;IACvB,0CAA0C;AAC9C;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;;IAEI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;IACf,mCAAmC;IACnC,mBAAmB;IACnB,4BAA4B;IAC5B,sBAAsB;IACtB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;;IAEI,kBAAkB;IAClB,0CAA0C;IAC1C,sBAAsB;IACtB,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,uCAAuC;AAC3C;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;IACvB,kCAAkC;IAClC,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI;QACI,gDAAgD;IACpD;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;;QAEI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;QACI,eAAe;IACnB;;IAEA;;;QAGI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,WAAW;QACX,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,WAAW;QACX,uBAAuB;IAC3B;AACJ","sourcesContent":[".hmi-home {\n    --hmi-bg: #F5F7FB;\n    --hmi-card: #FFFFFF;\n    --hmi-accent: #2563EB;\n    --hmi-accent-ink: #FFFFFF;\n    --hmi-text: #0F172A;\n    --hmi-muted: #475569;\n    --hmi-hover: #EEF4FF;\n    --hmi-border: #E2E8F0;\n    --hmi-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 10px 28px rgba(15, 23, 42, 0.05);\n    --hmi-row: #F8FAFC;\n    --hmi-good: #047857;\n    --hmi-good-bg: #ECFDF5;\n    --hmi-warn: #B45309;\n    --hmi-warn-bg: #FFFBEB;\n    --hmi-danger: #B91C1C;\n    --hmi-danger-bg: #FEF2F2;\n    --hmi-input: #FFFFFF;\n    color-scheme: light;\n    box-sizing: border-box;\n    min-height: calc(100vh - 64px);\n    padding: 28px 32px 40px;\n    background: var(--hmi-bg);\n    color: var(--hmi-text);\n    font-family: \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n}\n\n.hmi-home[data-theme=\"dark\"] {\n    --hmi-bg: #0B1220;\n    --hmi-card: #172033;\n    --hmi-accent: #38BDF8;\n    --hmi-accent-ink: #082033;\n    --hmi-text: #F1F5F9;\n    --hmi-muted: #CBD5E1;\n    --hmi-hover: #1E293B;\n    --hmi-border: #334155;\n    --hmi-shadow: 0 1px 2px rgba(0, 0, 0, 0.28), 0 12px 32px rgba(0, 0, 0, 0.22);\n    --hmi-row: #121A2B;\n    --hmi-good: #34D399;\n    --hmi-good-bg: rgba(52, 211, 153, 0.12);\n    --hmi-warn: #FBBF24;\n    --hmi-warn-bg: rgba(251, 191, 36, 0.12);\n    --hmi-danger: #FCA5A5;\n    --hmi-danger-bg: rgba(248, 113, 113, 0.12);\n    --hmi-input: #0F172A;\n    color-scheme: dark;\n}\n\n.hmi-home *,\n.hmi-home *::before,\n.hmi-home *::after {\n    box-sizing: border-box;\n}\n\n.hmi-home h1,\n.hmi-home h2,\n.hmi-home p {\n    margin: 0;\n    color: var(--hmi-text);\n}\n\n.hmi-home__top {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 24px;\n    margin-bottom: 22px;\n}\n\n.hmi-home__eyebrow {\n    margin-bottom: 6px;\n    color: var(--hmi-accent);\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n}\n\n.hmi-home__intro h1 {\n    color: var(--hmi-text);\n    font-size: 32px;\n    line-height: 1.15;\n    font-weight: 700;\n    letter-spacing: -0.03em;\n}\n\n.hmi-home p.hmi-home__subtitle {\n    margin-top: 6px;\n    color: var(--hmi-muted);\n    font-size: 15px;\n}\n\n.hmi-home__meta {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    gap: 12px;\n    min-width: min(100%, 520px);\n}\n\n.hmi-home__clock,\n.hmi-home__refresh,\n.hmi-home__theme {\n    border: 1px solid var(--hmi-border);\n    background: var(--hmi-card);\n    box-shadow: var(--hmi-shadow);\n}\n\n.hmi-home__clock,\n.hmi-home__refresh {\n    border-radius: 14px;\n    padding: 12px 14px;\n    min-width: 220px;\n}\n\n.hmi-home__meta-label {\n    display: block;\n    margin-bottom: 4px;\n    color: var(--hmi-muted);\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n}\n\n.hmi-home__clock strong,\n.hmi-home__refresh strong {\n    display: block;\n    font-size: 14px;\n    font-weight: 600;\n    font-variant-numeric: tabular-nums;\n}\n\n.hmi-home__theme {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    height: 64px;\n    padding: 0 16px;\n    border-radius: 14px;\n    color: var(--hmi-text);\n    font: inherit;\n    font-size: 14px;\n    font-weight: 700;\n    cursor: pointer;\n    transition: border-color 0.15s ease, background-color 0.15s ease, color 0.15s ease;\n}\n\n.hmi-home__theme svg,\n.hmi-home__shortcut svg,\n.hmi-kpi__icon svg {\n    width: 18px;\n    height: 18px;\n    display: block;\n}\n\n.hmi-home__theme:hover,\n.hmi-home__theme:focus-visible,\n.hmi-home__shortcut:hover,\n.hmi-home__shortcut:focus-visible {\n    border-color: var(--hmi-accent);\n    outline: none;\n}\n\n.hmi-home__theme:focus-visible,\n.hmi-home__shortcut:focus-visible,\n.hmi-home__field input:focus-visible,\n.hmi-home__field select:focus-visible,\n.hmi-home__table button:focus-visible {\n    outline: 2px solid var(--hmi-accent);\n    outline-offset: 2px;\n}\n\n.hmi-home__refresh.is-refreshing strong {\n    color: var(--hmi-accent);\n}\n\n.hmi-home__refresh.is-error {\n    border-color: var(--hmi-danger);\n}\n\n.hmi-home__refresh-error {\n    display: block;\n    margin-top: 4px;\n    color: var(--hmi-danger);\n    font-size: 12px;\n    font-weight: 600;\n}\n\n.hmi-home__shortcuts {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    margin-bottom: 22px;\n}\n\n.hmi-home__shortcuts a {\n    text-decoration: none;\n}\n\n.hmi-home__shortcut {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 16px;\n    border: 1px solid var(--hmi-accent);\n    border-radius: 12px;\n    background: var(--hmi-card);\n    color: var(--hmi-accent);\n    font: inherit;\n    font-size: 14px;\n    font-weight: 700;\n    cursor: pointer;\n    box-shadow: var(--hmi-shadow);\n    transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n}\n\n.hmi-home__shortcut:hover,\n.hmi-home__shortcut:focus-visible {\n    background: var(--hmi-accent);\n    color: var(--hmi-accent-ink);\n}\n\n.hmi-home__kpis {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 14px;\n    margin-bottom: 18px;\n}\n\n.hmi-kpi {\n    display: flex;\n    gap: 14px;\n    align-items: center;\n    min-height: 124px;\n    padding: 18px 18px 16px;\n    border: 1px solid var(--hmi-border);\n    border-radius: 16px;\n    background: var(--hmi-card);\n    box-shadow: var(--hmi-shadow);\n}\n\n.hmi-kpi__icon {\n    display: grid;\n    place-items: center;\n    width: 40px;\n    height: 40px;\n    flex: 0 0 40px;\n    border-radius: 12px;\n    background: rgba(37, 99, 235, 0.1);\n    color: var(--hmi-accent);\n}\n\n.hmi-home[data-theme=\"dark\"] .hmi-kpi__icon {\n    background: rgba(56, 189, 248, 0.12);\n}\n\n.hmi-kpi--good .hmi-kpi__icon {\n    background: var(--hmi-good-bg);\n    color: var(--hmi-good);\n}\n\n.hmi-kpi--warn .hmi-kpi__icon {\n    background: var(--hmi-warn-bg);\n    color: var(--hmi-warn);\n}\n\n.hmi-home p.hmi-kpi__label {\n    color: var(--hmi-muted);\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n}\n\n.hmi-kpi__value {\n    margin: 6px 0 4px;\n    color: var(--hmi-text);\n    font-size: 30px;\n    line-height: 1;\n    font-weight: 700;\n    font-variant-numeric: tabular-nums;\n    letter-spacing: -0.03em;\n}\n\n.hmi-home p.hmi-kpi__hint {\n    color: var(--hmi-muted);\n    font-size: 12px;\n    line-height: 1.4;\n}\n\n.hmi-home__panel {\n    border: 1px solid var(--hmi-border);\n    border-radius: 18px;\n    background: var(--hmi-card);\n    box-shadow: var(--hmi-shadow);\n    overflow: hidden;\n}\n\n.hmi-home__panel-head {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    gap: 18px;\n    padding: 18px 18px 14px;\n    border-bottom: 1px solid var(--hmi-border);\n}\n\n.hmi-home__panel-head h2 {\n    color: var(--hmi-text);\n    font-size: 18px;\n    letter-spacing: -0.02em;\n}\n\n.hmi-home .hmi-home__panel-head p {\n    margin-top: 4px;\n    color: var(--hmi-muted);\n    font-size: 13px;\n}\n\n.hmi-home__tools {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    gap: 10px;\n}\n\n.hmi-home__field {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    min-width: 200px;\n}\n\n.hmi-home__field span {\n    color: var(--hmi-muted);\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n}\n\n.hmi-home__field input,\n.hmi-home__field select {\n    height: 40px;\n    width: 100%;\n    max-width: none;\n    padding: 0 12px;\n    border: 1px solid var(--hmi-border);\n    border-radius: 10px;\n    background: var(--hmi-input);\n    color: var(--hmi-text);\n    font: inherit;\n    font-size: 14px;\n}\n\n.hmi-home__state {\n    padding: 36px 18px;\n    color: var(--hmi-muted);\n    text-align: center;\n    font-size: 14px;\n}\n\n.hmi-home__state--error {\n    color: var(--hmi-danger);\n}\n\n.hmi-home__table-wrap {\n    width: 100%;\n    overflow-x: auto;\n}\n\n.hmi-home__table {\n    width: 100%;\n    min-width: 760px;\n    border-collapse: collapse;\n}\n\n.hmi-home__table th,\n.hmi-home__table td {\n    padding: 13px 16px;\n    border-bottom: 1px solid var(--hmi-border);\n    color: var(--hmi-text);\n    text-align: left;\n    vertical-align: middle;\n    font-size: 14px;\n    transition: background-color 0.15s ease;\n}\n\n.hmi-home__table th {\n    background: var(--hmi-row);\n    color: var(--hmi-muted);\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    white-space: nowrap;\n}\n\n.hmi-home__table button {\n    padding: 0;\n    border: 0;\n    background: transparent;\n    color: inherit;\n    font: inherit;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    cursor: pointer;\n}\n\n.hmi-home__table button:hover {\n    color: var(--hmi-accent);\n}\n\n.hmi-home__table tbody tr:last-child td {\n    border-bottom: 0;\n}\n\n.hmi-home__table tbody tr:hover td {\n    background: var(--hmi-hover);\n}\n\n.hmi-home__tag-name {\n    font-weight: 600;\n}\n\n.hmi-home__value {\n    color: var(--hmi-text);\n    font-weight: 700;\n    font-variant-numeric: tabular-nums;\n}\n\n.hmi-home__table td.hmi-home__time {\n    color: var(--hmi-muted);\n    font-variant-numeric: tabular-nums;\n    letter-spacing: 0.01em;\n    white-space: nowrap;\n}\n\n.hmi-home__status {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 9px;\n    border-radius: 999px;\n    font-size: 12px;\n    font-weight: 700;\n    white-space: nowrap;\n}\n\n.hmi-home__status::before {\n    content: \"\";\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    background: currentColor;\n}\n\n.hmi-home__status.is-available {\n    color: var(--hmi-good);\n    background: var(--hmi-good-bg);\n}\n\n.hmi-home__status.is-missing {\n    color: var(--hmi-warn);\n    background: var(--hmi-warn-bg);\n}\n\n@media (max-width: 1100px) {\n    .hmi-home__kpis {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n}\n\n@media (max-width: 800px) {\n    .hmi-home {\n        padding: 18px 14px 28px;\n    }\n\n    .hmi-home__top,\n    .hmi-home__panel-head {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .hmi-home__meta,\n    .hmi-home__tools {\n        justify-content: flex-start;\n    }\n\n    .hmi-home__intro h1 {\n        font-size: 26px;\n    }\n\n    .hmi-home__clock,\n    .hmi-home__refresh,\n    .hmi-home__field {\n        min-width: 0;\n        width: 100%;\n    }\n\n    .hmi-home__theme {\n        width: 100%;\n        justify-content: center;\n    }\n}\n\n@media (max-width: 560px) {\n    .hmi-home__kpis {\n        grid-template-columns: 1fr;\n    }\n\n    .hmi-home__shortcut {\n        width: 100%;\n        justify-content: center;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
